<template>
	<div>
		<v-data-table
			v-if="hasItens"
			v-model="itensSelecionados"
			:headers="colunas"
			:items="itens"
			item-key="id"
			show-select
			hide-default-footer
			:server-items-length="totalItens"
			:options="paginacaoInterna"
			class="arp-listview mt-5 row-pointer"
		>
			<template #item.idOrgao="{ item }">
				{{ item.siglaOrgao }}
			</template>
			<template #item.exercicio="{ item }">
				{{ item.exercicio }}
			</template>
			<template #item.elementoSubElemento="{ item }">
				<span class="description-limitation">
					<texto-tooltip
						:texto="`${item.elementoSubElemento.codigo} - ${item.elementoSubElemento.descricao}`"
						:tamanho-maximo="40"
					></texto-tooltip>
				</span>
			</template>
			<template #item.funcaoProgramatica="{ item }">
				<span class="description-limitation">
					<texto-tooltip :texto="`${item.funcaoProgramatica.codigo}`" :tamanho-maximo="40"></texto-tooltip>
				</span>
			</template>
			<template #item.fonteRecursoFinanceiro="{ item }">
				<span class="description-limitation">
					<texto-tooltip :texto="item.fonteRecursoFinanceiro.codigo" :tamanho-maximo="40"></texto-tooltip>
				</span>
			</template>
		</v-data-table>

		<template-listagem-vazia
			:total-itens="totalItens"
			:textos="textosDoTemplateDaListagemVazia"
		></template-listagem-vazia>

		<paginacao-tabela
			v-if="hasItens"
			:page.sync="paginacaoInterna.page"
			:rows-per-page.sync="paginacaoInterna.rowsPerPage"
			:totalPaginas="totalPaginas"
			:totalItens="totalItens"
			@resetar-page="resetarPaginacao"
		></paginacao-tabela>
	</div>
</template>

<script>
import PaginacaoTabela from '@/views/components/PaginacaoTabela.vue'
import TextoTooltip from '@/views/components/TextoTooltip.vue'
import tabelaMixin from '@/views/mixins/tabela'
import { TabelaColunaUtils } from '@/core/utils'
import TemplateListagemVazia from '@/views/components/TemplateListagemVazia.vue'

export default {
	name: 'selecao-dotacao-orcamentaria-listagem',
	components: { TemplateListagemVazia, TextoTooltip, PaginacaoTabela },
	mixins: [tabelaMixin],
	props: {
		itens: {
			type: Array,
			required: true,
		},
		value: {
			type: Array,
			required: true,
		},
	},

	data() {
		return {
			textosDoTemplateDaListagemVazia: {
				titulo: 'Nenhuma dotação orçamentária por aqui.',
			},
			paginacaoInterna: this.paginacao,
			colunas: [
				new TabelaColunaUtils('Órgão', 'idOrgao', '5%'),
				new TabelaColunaUtils('Exercício', 'anoExercicio', '5%'),
				new TabelaColunaUtils('Natureza Despesa', 'elementoSubElemento', '25%'),
				new TabelaColunaUtils('Função Programática', 'funcaoProgramatica', '35%'),
				new TabelaColunaUtils('Fonte Recurso', 'fonteRecursoFinanceiro', '25%'),
			],
		}
	},

	computed: {
		itensSelecionados: {
			set(newValue) {
				return this.$emit('input', newValue)
			},
			get() {
				return this.value
			},
		},
	},

	methods: {
		resetarPaginacao() {
			this.$emit('resetar-page')
		},
	},
}
</script>
<style lang="stylus" scoped>
::v-deep .v-data-table__empty-wrapper
	height inherit !important
.row-size {
	display: flex;
	justify-content: center;
	align-items: center;
	height: 22vh;
}
.description-limitation {
	text-overflow: ellipsis;
	overflow: hidden;
	-webkit-line-clamp: 1;
	-webkit-box-orient: vertical;
	display: block;
	display: -webkit-box;
	max-height: 48px;
}
</style>
